/**
 *
 * UserTable
 *
 */

import * as React from 'react';

import { DeleteOutlined } from '@ant-design/icons';

import { InputNumber, Table } from 'antd';

import styled from 'styled-components';
import translations from 'translations';
import { OrderItem, Product } from 'types/schema';
import calculateVAT from 'utils/calculateVAT';
import formatMoney from 'utils/formatMoney';
import utilsMessages from 'utils/messages';
import noImage from './noIMG.svg';
import { FormattedMessage } from 'react-intl';

interface OwnProps {
  items: any;
  editedOrderItems: {};
  onSetQuantity: (data) => void;
  onDeleteItem: (data) => void;
}

const Container = styled.div`
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  .ant-table tbody tr {
    cursor: pointer;
  }
  .ant-table-thead > tr > th {
    background: #f5f5f4;
  }
  tbody {
    background-color: white;
  }
`;

const Text = styled.p`
  font-weight: 500;
  font-size: 14px;
  color: #343538;
`;
const Note = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #808289;
`;
const ItemImg = styled.img`
  width: 56px;
  height: 56px;
`;
const ItemWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;
const ItemInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const INumber = styled(InputNumber)`
  height: 40px;

  .ant-input-number-input {
    height: 40px !important;
  }
`;

const OrderItemTable = (props: OwnProps) => {
  const columnsConfig = [
    {
      title: `${translations(utilsMessages.itemName)} (${props.items.length})`,
      key: 'product',
      dataIndex: 'product',
      render: (product: Product, item: OrderItem) => {
        return (
          <ItemWrapper>
            <ItemImg src={product.imageUrl || noImage} alt={product.name} />
            <ItemInfoWrapper>
              <Text>{product.name}</Text>
              {item.buyerNote && <Note>{item.buyerNote}</Note>}
            </ItemInfoWrapper>
          </ItemWrapper>
        );
      },
      width: 460,
    },
    {
      title: <FormattedMessage {...utilsMessages.priceBeforeVat} values={{ break: <br /> }} />,
      key: 'product',
      dataIndex: 'product',
      align: 'right',
      width: 200,
      render: (_, record: OrderItem) => (
        <Text>
          {formatMoney(
            calculateVAT(record?.priceV2?.price || 0, record?.priceV2?.vat || 0, record?.priceV2?.vatIncluded || false)
              .beforeVat,
          )}
        </Text>
      ),
    },
    {
      title: translations(utilsMessages.quantity),
      key: 'quantity',
      width: 200,
      render: (item: OrderItem) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <INumber
            size="small"
            min={0.001}
            value={props.editedOrderItems[item.product.id] || item.orderedQuantity}
            onChange={(value) => {
              if (!value) return;
              props.onSetQuantity({ quantity: value, itemId: item.product.id });
            }}
          />
          <p>{item.product.uomLocal}</p>
        </div>
      ),
    },
    {
      title: '',
      key: 'deleteItem',
      render: (item) => <DeleteOutlined onClick={() => props.onDeleteItem(item.product.id)} />,
      width: 60,
    },
  ];

  return (
    <Container>
      <Table dataSource={props.items} columns={columnsConfig} pagination={false} />
    </Container>
  );
};

export default OrderItemTable;
